export default class Error implements Data {

    error: Data

    constructor() {
        this.error = {};
    }

    any(): boolean {
        return Object.keys(this.error).length !== 0;
    }

    get(field: string): any {
        if (this.error[field]) {
            return this.error[field][0];
        }
    }

    has(field: string): boolean {
        return this.error && this.error[field];
    }

    record(error: any): void {
        this.error = error;
    }

    clear(field: string): void {
        delete this.error[field];
    }
}
